export function useInfo() {

    const router = useRouter(); 
    const route = useRoute();

    const ages = [
        {id:"ADULT",label:"Yetişkin"},
        {id:"CHILD",label:"Çocuk"},
        {id:"BABY",label:"Bebek"}
    ]
    const paymentMethods = [
        {id:"CASH",label:"Nakit"},
        {id:"BANKTRANSFER",label:"Havale/Eft"},
        {id:"CREDITCARD",label:"Kredi Kartı"}
    ]
    const cusomerTypes = [
        {id:"OZEL",label:"OZEL"},
        {id:"TUZEL",label:"TUZEL"}, 
    ]
    const currencies = [
        {id:"USD",label:"USD"},
        {id:"TRY",label:"TRY"},
        {id:"EUR",label:"EURO"},
        {id:"SAR",label:"SAR"}
    ]
    const abbrCurr = {
        "USD": "$",
        "TRY": "₺",
        "EUR": "€",
        "SAR": "SR",
    }
    const gender = [
        {id:"MALE",label:"Erkek"},
        {id:"FEMALE",label:"Kadın"} 
    ]
    const gifts = [
        {id:"NONE",label:"İşlem Bekliyor"},
        {id:"SENT",label:"Kargolandı"},
        {id:"GIVEN",label:"Teslim Edildi"} ,
        {id:"NOTNEED",label:"Verilmeyecek"},
        {id:"ATAIRPORT",label:"Havalimanında"} ,
        {id:"WILLOFFICE",label:"Ofisten Alacak"} ,
    ]
    const nationalities = [
        { "id": "TUR", "label": "Türk", "label_en": "Turkish" },
        { "id": "DE", "label": "Alman", "label_en": "German" },
        { "id": "AF", "label": "Afgan", "label_en": "Afghan" },
        { "id": "AL", "label": "Arnavut", "label_en": "Albanian" },
        { "id": "DZ", "label": "Cezayirli", "label_en": "Algerian" },
        { "id": "US", "label": "Amerikan", "label_en": "American" },
        { "id": "AR", "label": "Arjantinli", "label_en": "Argentine" },
        { "id": "AU", "label": "Avustralyalı", "label_en": "Australian" },
        { "id": "AT", "label": "Avusturyalı", "label_en": "Austrian" },
        { "id": "AZ", "label": "Azeri", "label_en": "Azerbaijani" },
        { "id": "BD", "label": "Bangladeşli", "label_en": "Bangladeshi" },
        { "id": "BE", "label": "Belçikalı", "label_en": "Belgian" },
        { "id": "BR", "label": "Brezilyalı", "label_en": "Brazilian" },
        { "id": "CA", "label": "Kanadalı", "label_en": "Canadian" },
        { "id": "CN", "label": "Çinli", "label_en": "Chinese" },
        { "id": "FR", "label": "Fransız", "label_en": "French" },
      
        { "id": "IN", "label": "Hintli", "label_en": "Indian" },
        { "id": "IR", "label": "İranlı", "label_en": "Iranian" },
        { "id": "IQ", "label": "Iraklı", "label_en": "Iraqi" },
        { "id": "IT", "label": "İtalyan", "label_en": "Italian" },
        { "id": "JP", "label": "Japon", "label_en": "Japanese" },
        { "id": "KR", "label": "Güney Koreli", "label_en": "South Korean" },
        { "id": "MX", "label": "Meksikalı", "label_en": "Mexican" },
        { "id": "NL", "label": "Hollandalı", "label_en": "Dutch" },
        { "id": "RU", "label": "Rus", "label_en": "Russian" },
        { "id": "SA", "label": "Suudi", "label_en": "Saudi" },
        { "id": "ES", "label": "İspanyol", "label_en": "Spanish" }, 
        { "id": "GB", "label": "İngiliz", "label_en": "British" },
        { "id": "VN", "label": "Vietnamlı", "label_en": "Vietnamese" },
        { "id": "CHE", "label": "İsviçre", "label_en": "Swiss" }
    ]
    // const operationTypes = [
    //     {id:"PAYMENT",label:"ODEME"},
    //     {id:"ORDER",label:"SIPARIS"},
    //     {id:"BILL",label:"HARCAMA"},
    // ]
    const transactionTypes = [
        // **Müşteri İşlemleri**
       
        { id: "DEBIT_PAYMENT",  label: "TAHSİLAT YAP",      effect: "PAYMENT" }, // Müşteriden tahsilat (borç kapatma)
        { id: "CREDIT_PAYMENT", label: "ÖDEME YAP",     effect: "PAYMENT" }, // Müşteriden tahsilat (borç kapatma)
        { id: "DEBIT_ORDER",    label: "SATIŞ FATURASI",    effect: "ORDER" }, // Müşteriye borç (alacak)
        { id: "CREDIT_ORDER",   label: "ALIŞ FATURA",     effect: "ORDER" }, // Müşteriye borç (alacak) 
    
        // // **Tedarikçi İşlemleri**
        // { id: "DEBIT_CREDIT_SUPPLIER_INVOICE", label: "TEDARİKÇİ FATURASI", effect: "CREDIT" }, // Otelin kestiği fatura (borç)
        // { id: "DEBIT_SUPPLIER_PAYMENT", label: "TEDARİKÇİ ÖDEMESİ", effect: "DEBIT" }, // Otele yapılan ödeme (borç kapatma)
    
        // // **Genel Giderler**
        // { id: "DEBIT_EXPENSE", label: "GENEL GİDER", effect: "DEBIT" }, // Elektrik, su vb. giderler (borç)
        // { id: "DEBIT_SALARY_PAYMENT", label: "MAAŞ ÖDEMESİ", effect: "DEBIT" }, // Personel maaş ödemesi (borç)
        // { id: "DEBIT_TAX_PAYMENT", label: "VERGİ ÖDEMESİ", effect: "DEBIT" }, // Vergi, SGK ödemeleri (borç)
    
        // // **Diğer Gelirler**
        // { id: "CREDIT_OTHER_INCOME", label: "DİĞER GELİR", effect: "CREDIT" }, // Ekstra gelirler (alacak)
    ];
    const paymentReponsibles = [
        {id:"first",label:"İlk kişi"},
        {id:"roomfirst",label:"Odadaki ilk kişi"},
        {id:"own",label:"Kendisi"},
        {id:"other",label:"Diğer"},
    ]

    const excludeTypes = [
        {id:"flight",label:"Uçak Bileti"},
        {id:"visa",label:"Vize"},
        {id:"medinaHotel",label:"Medine Otel"},
        {id:"makkahHotel",label:"Mekke Otel"},
        {id:"other",label:"Diğer"},
    ]

    const extraServiceTypes = [ 
        {id:"flight_connecting_2direction",service:'flight', icon: 'fa-solid fa-plane-departure',  label:"Aktarma Uçuş"},
        {id:"train", service:'train', icon: 'fa-solid fa-train',    label:"Hızlı Tren", price: "150"},
        {id:"train_bussiness", service:'train', icon: 'fa-solid fa-train',    label:"Hızlı Tren (Bussiness Bilet)" , price: "220"},
       
        {id:"flight_connecting_start",service:'flight',  icon: 'fa-solid fa-plane-departure',   label:"Gidiş Aktarma Uçuş"},
        {id:"flight_connecting_end",service:'flight',   icon: 'fa-solid fa-plane-departure',  label:"Dönüş Aktarma Uçuş"},
        {id:"mekke_kabe",       service:'hotel',  icon: 'fa-solid fa-hotel',    label:"Kabe Manzaralı Oda"},
        {id:"visa_extra",       service:'visa',   icon: 'fa-solid fa-passport',   label:"Vize Extra"},
        {id:"medine_extrabed",  service:'hotel',  icon: 'fa-solid fa-hotel',   label:"Medine Ektra Yatak"},
        {id:"mekke_extrabed",   service:'hotel', icon: 'fa-solid fa-hotel',    label:"Mekke Ektra Yatak"}, 
        {id:"flight_bussiness", service:'flight', icon: 'fa-solid fa-plane-departure',    label:"Bilet Bussiness"},
        {id:"other",service:'other', icon: 'fa-solid fa-list',label:"Diğer"},
    ];
 

    const searchQuestions = ref({
        when:[
            // {id:"02",count:1, short: "Şub",label:"Şubat", selected:false},
            // {id:"03",count:2, short: "Mar", "Nis",label:"Mart", selected:false},
            //{id:"04-24",count:11, short: "Nis", label:"Nisan", selected:false},
            //{id:"05-24",count:8,  short: "May", label:"Mayıs", selected:false},
            //{id:"06-24",count:7,  short: "Haz", label:"Haziran", selected:false},
            // {id:"07-26",count:6,  short: "Tem", label:"Temmuz", selected:false},
            // {id:"08-26",count:5,  short: "Ağu", label:"Ağustos", selected:false},
            // {id:"09-26",count:2,  short: "Eyl", label:"Eylül", selected:false},
            // {id:"10-26",count:2,  short: "Eki", label:"Ekim", selected:false},
            {id:"11-26",count:2,  short: "Kas", label:"Kasım", selected:false},
            {id:"12-26",count:2,  short: "Ara", label:"Aralık", selected:false},
            {id:"01-27",count:1, short: "Oca",label:"Ocak", selected:false},
            {id:"02-27",count:1, short: "Şub",label:"Şubat", selected:false},
            {id:"03-27",count:1, short: "Mar",label:"Mart", selected:false},
            // {id:"04-27",count:1, short: "Nis",label:"Nisan", selected:false},
        ],
        where:[ 
            {selected: false, id:"balkan",label:"Balkanlar"},
            {selected: false, id:"dubai",label:"Dubai"},
            {selected: false, id:"misir",label:"Mısır"},
            {selected: false, id:"fas",label:"Fas"},

            {selected: false, id:"umrah",label:"Umre"},
            // {selected: false, id:"kazakistan",label:"Kazakistan"}
        ],
        umrahCategory:[
            {selected: false, id:"1",label:"Ramazan Umre Turları"},
            {selected: false, id:"2",label:"Kandil Umre Turları"},
            {selected: false, id:"3",label:"Yaz Umre Turları"},
            {selected: false, id:"4",label:"Kısa Umre Programları"}
        ],
        duration:[
            {selected: false, id:"5-8",label:"5-8 Gün"},
            {selected: false, id:"9-11",label:"9-10 gün"}, 
            {selected: false, id:"+11",label:"11+ Gün"} 
        ]
    })

    const data = [
        {
            url: "/tours/rota-yurtdisi-turlari",
            title: "Yurtdışı Turlar"
        },
        {
            url: "/tours/rota-kudus-turlari",
            title: "Kudüs Turları"
        }
        ,
        {
            url: "/tours/rota-misir-turlari",
            title: "Mısır Turları"
        },
        {
            url: "/tours/rota-fas-turlari",
            title: "Fas Turları"
        },
        {
            url: "/tours/rota-tunus-turlari",
            title: "Tunus Turları"
        },
        {
            url: "/tours/rota-dubai-turlari",
            title: "Dubai Turları"
        },
        {
            url: "/tours/rota-bosna-hersek-turlari",
            title: "Bosna Hersek Turları"
        },
        {
            url: "/tours/rota-balkan-turlari",
            title: "Balkan Turları"
        } 
    ]

    const tours = [
        {
            title: "Bosna  Hersek Turları",
            url: "/tours/rota-bosna-hersek-turlari",
            img: "/assets/img/tours/bosna.webp",
            duration: "3-5",
            recomended: true,
            isActive: true,
            ///headTitle: "ÇOK YAKINDA"
    
        },
        {
            title: "Fas Turları",
            url: "/tours/rota-fas-turlari",
            img: "/assets/img/tours/fas-turlari.webp",
            mobileImage: "/assets/img/tours/fas-turlari-mobile.webp",
            duration: "3-8",
            recomended: false,
            isActive: true,
            //headTitle: "ÇOK YAKINDA"
    
        },
        {
            title: "Kudüs Turları",
            url: "/tours/rota-kudus-turlari",
            img: "/assets/img/tours/kudus-turlari.webp",
            duration: "2-5",
            recomended: false,
            isActive: true,
            //headTitle: "ÇOK YAKINDA"
    
        },
        {
            title: "Dubai Turları",
            url: "/tours/rota-dubai-turlari",
            img: "/assets/img/tours/dubai-turlari.webp",
            mobileImage: "/assets/img/tours/dubai-turlari-mobile.avif",
            duration: "3-5",
            recomended: false,
            isActive: true,
            headTitle: "ÇOK YAKINDA"
    
        },
        {
            url: "/tours/rota-misir-turlari",
            title: "Mısır Turları",
            img: "/assets/img/tours/egypt.webp",
            mobileImage: "/assets/img/tours/egypt-mobile-180.webp",
            duration: "3-8",
            recomended: false,
            isActive: true,
            headTitle: "ÇOK YAKINDA"
    
        },
        {
            url: "/tours/rota-balkan-turlari",
            title: "Balkan Turları",
            img: "/assets/img/tours/balkans.webp",
            mobileImage: "/assets/img/tours/balkans-mobile.webp",
            duration: "3-8",
            recomended: false,
            isActive: true,
            headTitle: "ÇOK YAKINDA"
    
        }
    ];

    const tourPrograms = {
        "rota-bosna-hersek-turlari" : {
            1: {
                title:'3 günlük Bosna-Hersek Turu',
                duration: 3,
                highlight: 'ISTANBUL-SARAYBOSNA-MOSTAR',
                image: '',
                content: `<div class="markdown prose w-full break-words dark:prose-invert light"><p><strong>1. Gün: Saraybosna'ya Geliş</strong></p><ul><li>Sabah İstanbul'dan uçakla Saraybosna'ya varış.</li><li>Havalimanında karşılama ve otel transferi.</li><li>Otele yerleşme ve dinlenme.</li><li>Şehir merkezine kısa bir yürüyüş ve akşam yemeği için yerel restoran ziyareti.</li></ul><p><strong>2. Gün: Saraybosna Şehir Turu</strong></p><ul><li>Kahvaltının ardından Saraybosna şehir turuna başlama.</li><li>Başlıca turistik noktalar arasında Eski Şehir (Bascarsija), Latin Köprüsü, Gazi Husrev Bey Camii, Saat Kulesi ve Srebrenica Anıtı bulunmaktadır.</li><li>Öğle yemeği için yerel bir restoranda Bosna-Hersek mutfağından lezzetler deneme şansı.</li><li>Serbest zaman ve dileyenler için akşam yemeği için serbest zaman.</li></ul><p><strong>3. Gün: Mostar Ziyareti ve Dönüş</strong></p><ul><li>Kahvaltının ardından Mostar'a doğru yola çıkış.</li><li>Mostar'a varış ve UNESCO Dünya Mirası Listesi'nde yer alan Mostar Köprüsü ve Eski Köprü'yu ziyaret etme fırsatı.</li><li>Öğle yemeği için Mostar'da serbest zaman.</li><li>Mostar'da geçirilen zamanın ardından Saraybosna'ya dönüş.</li><li>Akşam saatlerinde Saraybosna Havalimanı'na transfer ve İstanbul'a dönüş uçuşu.</li></ul></div>`
            }
        }
    }

    const notStatus = [
        {color: "blue",     "name":"Aktif","id":"1330","value":"Not_Active"},
        {color: "orange",   "name":"Cevap Bekleniyor","id":"1331","value":"Not_Waiting"},
        {color: "rose",     "name":"Teklif Verilecek","id":"1332","value":"Not_Offering"},
        {color: "sky",      "name":"Bilgi Veriliyor","id":"1334","value":"Not_Informing"},
        {color: "teal",     "name":"Kayıt Oldu","id":"1335","value":"Not_Successfull"},
        {color: "red",     "name":"İptal","id":"1967","value":"Not_Cancelled"},
        {color: "purple", "name":"Eylul Umre","id":"1965","value":"EYLULUMRE"},
        {color: "purple", "name":"Ekim Umre","id":"1966","value":"EKIM"},
        {color: "purple", "name":"Kasım Umre","id":"1967","value":"KASIM"},
        {color: "purple", "name":"Aralık Umre","id":"1968","value":"KASIM"},
        {color: "purple", "name":"Ocak Umre","id":"1968","value":"OCAK"},
        {color: "purple", "name":"Şubat Umre","id":"1968","value":"SUBAT"},
    ];
    const rezStatus = [
        {color: "green", "name":"Onaylı","id":"1333","value":"SD_Confirmed"},
        {color: "orange", "name":"Bekleyen","id":"1330","value":"SD_Waiting"}, 
        {color: "red", "name":"İptal","id":"1331","value":"SD_Cancelled"}
    ];
 
    const passportTypes =  [
        {id:"BORDO",label:"BORDO"},
        {id:"YESIL",label:"YEŞİL"},
        {id:"GRI",label:"GRI / OZEL HIZMET"},
        {id:"DIPLOMAT",label:"DİPLOMAT"},  
    ];
    const acents = [
        {id:"INANCTUR", name:"İnanç Turizm"},
        {id:"MUNEVVERTUR", name:"Münevver Turizm"},
        {id:"VISALTUR", name:"Visal Tur"}, 
        {id:"VAVTUR", name:"Vav Tur"}, 
        {id:"ADNANSENSOY", name:"Adnan Şensoy"}, 
        {id:"FATİHSAVAS", name:"Fatih Savaş"}, 
        {id:"OZERAKPINAR", name:"Özer Akpınar"},
        {id:"CEMAVCI", name:"Cem Avcı"},
        {id:"MUTLUDIKMEN", name:"Mutlu Dikmen"},
        {id:"VAHITAKDAG", name:"Vahit Akdağ"},
        {id:"MEHMETGEZGIN", name:"Mehmet Gezgin"}, 
        {id:"SERAPDERELI", name:"Serap Dereli"}, 
    ];

    return{
        data,
        tours,
        tourPrograms,
        searchQuestions,
        ages,
        gender,
        gifts,
        nationalities,
        notStatus,
        rezStatus,
        paymentReponsibles,
        extraServiceTypes,
        excludeTypes,
        currencies,
        transactionTypes,
        paymentMethods,
        cusomerTypes,
        abbrCurr,
        passportTypes,
        acents
    }
}
